export const WERKZEUGVERWALTUNG = 'werkzeugverwaltung';
export const MESSMITTELVERWALTUNG = 'messmittelverwaltung';
export const WERKZEUGVERWALTUNG_HISTORIE = 'werkzeugverwaltung/historie';
export const WERKZEUGVERWALTUNG_ABMUSTERUNG = 'werkzeugverwaltung/abmusterung';

export const MESSMITTELVERWALTUNGG_HISTORIE = 'messmittelverwaltung/historie';
export const SESSION = 'session';
export const PROZESSKONTROLLKARTE = 'prozesskontrollkarte';
export const ABMUSTERUNG = 'abmusterung';
export const WARENEINGANGSPRUEFUNG = 'wareningangspruefung';

export const INFRASTRUKTURVERWALTUNG = 'infrastrukturverwaltung';
export const INFRASTRUKTURVERWALTUNG_HISTORIE = 'infrastrukturverwaltung/historie';

export const STANDARDS = 'standards';
export const STANDARDS_HISTORIE = 'standards/historie';
